import { atom } from "jotai";
import {
  clearAccessToken,
  clearRefreshToken,
  setAccessToken,
  setRefreshToken,
} from "./graphqlApi";
import { clearLocalUser, setLocalUser } from "./localStorage";
import { atomWithStorage } from "jotai/utils";

const validateImageUrl = (url) => {
  return new Promise((resolve) => {
    if (!url) {
      resolve(null); // Return null for empty URL
      return;
    }

    // Set a timeout to prevent hanging
    const timeout = setTimeout(() => {
      resolve(null);
    }, 5000); // 5 second timeout

    const img = new Image();
    img.onload = () => {
      clearTimeout(timeout);
      // Check if image dimensions are at least 50x50 pixels
      if (img.width >= 50 && img.height >= 50) {
        resolve(url);
      } else {
        resolve(null);
      }
    };
    img.onerror = () => {
      clearTimeout(timeout);
      resolve(null);
    };
    img.src = url;
  });
};

export const currentUserAtom = atomWithStorage("user", null, undefined, {
  getOnInit: true,
});
export const promptAtom = atom({
  open: false,
  component: null,
  title: "",
  maxWidth: "md",
});

export const loginAtom = atom(null, async (_, set, auth) => {
  // Validate profile image URL
  const validImageUrl = await validateImageUrl(auth.user.photoURL);

  let user = {
    ...auth.user,
    name:
      [auth.user.firstName, auth.user.lastName].join(" ") || auth.user.username,
    image: validImageUrl, // Use validated image URL or null if invalid
    email: auth.user.username ? "@" + auth.user.username : "hidden",
    role: auth.role || auth.user.role, // Handle role from either location
  };
  set(currentUserAtom, user);
  setAccessToken(auth.jwt);
  setRefreshToken(auth.refreshToken);
  setLocalUser(user);
});

export const logoutAtom = atom(null, (_, set) => {
  logout(set);
});

const logout = (set) => {
  set(currentUserAtom, null);
  clearAccessToken();
  clearRefreshToken();
  clearLocalUser();
};
